import { addRovoParamsToUrl } from '@atlassian/conversation-assistant-pubsub';

const ATLAS_PROD_URL = 'https://home.atlassian.com';
const ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';

export const getAtlasHost = (): string => {
	const host = window.location.host;
	const isStaging =
		host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('jira-dev.com');

	return isStaging ? ATLAS_STAGING_URL : ATLAS_PROD_URL;
};

export const getAtlasURL = (cloudId: string, path: string) => {
	let argConcat = '?';
	let processedPath = path.startsWith('/') ? path : `/${path}`;

	if (processedPath.includes('?')) {
		argConcat = '&';
	}

	return addRovoParamsToUrl(`${getAtlasHost()}${processedPath}${argConcat}cloudId=${cloudId}`, {
		cloudId,
	});
};
